import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import Aura from '@primeng/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideAnimations } from '@angular/platform-browser/animations';
import { errorInterceptor } from './app/shared/http-interceptor/error-interceptor';
import { DialogService } from 'primeng/dynamicdialog';
import { NgxSpinnerModule } from 'ngx-spinner';
import { spinnerInterceptor } from './app/shared/http-interceptor/spinner-loader-interceptor';
import { authInterceptor } from './app/shared/http-interceptor/auth-interceptor';
import { CookieService } from 'ngx-cookie-service';

export const appConfig: ApplicationConfig = {
  providers: [
    DialogService,
    CookieService,
    provideRouter(
      appRoutes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled'
      }),
      withEnabledBlockingInitialNavigation()
    ),
    provideHttpClient(withFetch()),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimations(),
    providePrimeNG({
      theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } }
    }),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      })
    }),
    providePrimeNG(),
    provideHttpClient(withInterceptors([errorInterceptor])),
    provideHttpClient(withInterceptors([spinnerInterceptor])),
    NgxSpinnerModule
  ]
};
